import { useState, useEffect } from 'react';
import { Typography, Dialog, Table, TableRow, TableCell } from './../../../tailwindcomponents';
import { ToolData } from '../../../types/tool';
import toolsApi from './../../../api/tools';
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducer';
import ProfileImg from '../../../components/Images/ProfileImg';

interface DefectiveReportsProps {
  setLoading: (loading: boolean) => void;
}

function DefectiveReports({ setLoading }: DefectiveReportsProps) {
  const [defective_tools, setDefectiveTools] = useState(Array<ToolData>());
  const [order_by_text, setOrderByText] = useState("empty");
  const [ascending, setAscending] = useState(false);
  const [defective_tool_dialog_open, setDefectiveToolDialogOpen] = useState(false);
  const users = useSelector((state: RootState) => state.employees.all_employees);

  useEffect(() => {
    refresh(order_by_text, ascending);
  }, [order_by_text, ascending]);
  const generateTableBody = (row: ToolData, index: number) => {
    return (
      <TableRow>
        <TableCell>{index}</TableCell>
        <TableCell >
          <div className="flex items-center gap-2">
            <ProfileImg imgKey={index} imgSize="xs" userName={users.find(s => s.Id === row.employee_id)?.userName.split('@')[0]} />
            <Typography align="left" text={row.employee_name} display="inline"></Typography>
          </div>
        </TableCell>
        <TableCell>{row.description}</TableCell>
        <TableCell>{row.bay}</TableCell>
        <TableCell>{row.area}</TableCell>
        <TableCell>{row.out_date_text}</TableCell>
        <TableCell>{row.created_date_text}</TableCell>
        <TableCell>{row.reason}</TableCell>
      </TableRow>
    )
  }
  const OnOrderByTitles = (given_order_by_text: string) => {
    let temp_ascending = true;
    if (order_by_text === given_order_by_text) { temp_ascending = ascending === false ? true : false; }
    setAscending(temp_ascending);
    setOrderByText(given_order_by_text);
    refresh(given_order_by_text, temp_ascending);
  }
  const refresh = (order_by_text: string, ascending: boolean) => {
    setLoading(true);
    toolsApi.getAllDefectiveTools(order_by_text, ascending).then(res => {
      setDefectiveTools(res);
    }).finally(() => setLoading(false));
  }

  return (
    <div className="w-full">
      <Typography text={`Total defective tools (${defective_tools.length})`} align="center" variant={"h2"} />
      <Table
        headers={["Last used employee", "Tool", "Bay", "Area", "Loaned out", "Reported", "Reason"]}
        rows={defective_tools}
        generateBody={(row: any, index: number) => generateTableBody(row, index)}
        defaultRowsPerPage={100}
        OnOrderByTitles={(order_by_text: string) => OnOrderByTitles(order_by_text)}
      />
      <Dialog
        visible={defective_tool_dialog_open}
        max_width={"xl"} title={'asdasd'}
        context={
          <div className="w-full content-center items-center">
            <p></p>
          </div>
        }
        onClose={(status: any) => setDefectiveToolDialogOpen(false)}
        strict={false}
        show_options={true}
      />
    </div>
  );
};
export default DefectiveReports;